/**
 * Selector for retrieving the disabled sounds array.
 *
 * @param {Object} state - The Redux state.
 * @returns {Array<string>} - The disabled sound id's array.
 */
export function getDisabledSounds(state) {
    return state['features/base/config'].disabledSounds || [];
}
/**
 * Whether config turns a sound off. An entry also covers every id it prefixes,
 * so 'REACTION_SOUND' silences all the per-reaction variants.
 *
 * @param {string} soundId - The registered sound id.
 * @param {Array<string>} disabledSounds - The `config.disabledSounds` list.
 * @returns {boolean}
 */
export function isSoundDisabled(soundId, disabledSounds = []) {
    return disabledSounds.some(id => Boolean(id) && soundId.startsWith(id));
}
